import { WizardStepLocatorsMap } from '@app/common/configurable-wizards';
import { WizardSteps } from '../constants';
import { UserKindSelectStep } from './UserKindSelectStep';

export const steps: WizardStepLocatorsMap<WizardSteps> = new Map([
  [WizardSteps.UserKindSelect, UserKindSelectStep],
]);
